var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Preview"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M0.5 8C1.33333 6.16667 3.625 2.5 8 2.5C12.375 2.5 15.1875 6.16667 15.5 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M15.5 8C14.6667 9.83333 12.375 13.5 8 13.5C3.625 13.5 0.8125 9.83333 0.499999 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 8,
    cy: 8,
    r: 2,
    fill: "none",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.28699093f5d0e5b47239c7ba5b6d21a2.svg";
export { ForwardRef as ReactComponent };